class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.videos = this.querySelectorAll("video-gallery-element");
  }

  connectedCallback() {}

  showPiP(activeIndex) {
    document.querySelector(".pip-gallery")?.remove();
    document.body.insertAdjacentHTML(
      "beforeend",
      `
<div class="pip-gallery is-mute expanded">
  <div class="pip-gallery--wrapper">
    <button class="close-pip-gallery"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"/></svg></button>
    <div class="pip-gallery--navigation">
      <button class="navigate navigate-up" aria-label="Ver vídeo de cima">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon icon-up">
          <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
        </svg>
      </button>
      <button class="navigate navigate-down" aria-label="Ver vídeo de baixo">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon icon-down">
          <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
        </svg>
      </button>
    </div>
    <button aria-label="Mudo/Som" class="pip-gallery--mute">
      <span class="mute">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 24 24" 
          fill="currentColor" 
          class="icon icon-mute" 
        >
          <path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM17.78 9.22a.75.75 0 1 0-1.06 1.06L18.44 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L20.56 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72Z" />
        </svg>
      </span>
      <span class="unmute">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 24 24" 
          fill="currentColor" 
          class="icon icon-unmute"
        >
          <path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM18.584 5.106a.75.75 0 0 1 1.06 0c3.808 3.807 3.808 9.98 0 13.788a.75.75 0 0 1-1.06-1.06 8.25 8.25 0 0 0 0-11.668.75.75 0 0 1 0-1.06Z" />
          <path d="M15.932 7.757a.75.75 0 0 1 1.061 0 6 6 0 0 1 0 8.486.75.75 0 0 1-1.06-1.061 4.5 4.5 0 0 0 0-6.364.75.75 0 0 1 0-1.06Z" />
        </svg>
      </span>
    </button>
    <div class="pip-gallery-carousel">
    </div>
  </div>
</div>
      `
    );

    const gallery = document.querySelector(".pip-gallery");
    const carousel = document.querySelector(".pip-gallery-carousel");
    this.videos.forEach((video, index) => {
      const controlsWrapper = document.createElement("div");
      controlsWrapper.classList.add("controls-wrapper");

      const shareBtn = video.querySelector(".video-share").cloneNode(true);
      shareBtn.insertAdjacentHTML(
        "beforeend",
        `<span class="btn-tooltip">Compartilhar</span>`
      );

      controlsWrapper.appendChild(shareBtn);
      controlsWrapper.appendChild(video.form);

      const videoWrapper = document.createElement("div");
      videoWrapper.classList.add("video-wrapper");

      const videoEl = video.querySelector("video").cloneNode(true);

      const playBtn = document.createElement("button");
      playBtn.classList.add("play-wrapper");
      playBtn.insertAdjacentHTML(
        "beforeend",
        `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="icon icon-play">
  <path fill-rule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z" clip-rule="evenodd"></path>
</svg> 
        `
      );

      playBtn.addEventListener("click", function (e) {
        if (
          window.innerWidth > 1024 ||
          (window.innerWidth <= 1024 && gallery.classList.contains("expanded"))
        ) {
          videoWrapper.classList.toggle("playing");
          if (videoEl.paused) {
            videoEl.play();
          } else {
            videoEl.pause();
          }
        }
      });

      videoWrapper.appendChild(videoEl);
      videoWrapper.appendChild(controlsWrapper);
      videoWrapper.appendChild(playBtn);

      carousel.appendChild(videoWrapper);

      if (index == activeIndex) {
        videoWrapper.classList.add("playing");
        videoWrapper.classList.add("current");
        videoEl.play();
        videoEl.muted = true;
      }
    });

    const videoHeight = carousel.querySelector(".video-wrapper").offsetHeight;
    carousel.setAttribute("data-current-index", activeIndex);
    carousel.setAttribute("data-max-index", this.videos.length - 1);
    carousel.style.transform = `translateY(-${activeIndex * videoHeight}px)`;

    const mute = document.querySelector(".pip-gallery .pip-gallery--mute");
    const navUp = document.querySelector(".pip-gallery .navigate-up");
    const navDown = document.querySelector(".pip-gallery .navigate-down");

    mute.addEventListener("click", function (e) {
      gallery.classList.toggle("is-mute");
      const currVideo = carousel.querySelector(".video-wrapper.current");
      currVideo.querySelector("video").muted =
        gallery.classList.contains("is-mute");
    });

    navUp.addEventListener("click", function (e) {
      e.preventDefault();
      const currIndex = carousel.dataset.currentIndex;
      const maxIndex = carousel.dataset.maxIndex;

      if (currIndex === "0") return;

      const videoHeight = carousel.querySelector(".video-wrapper").offsetHeight;
      const currVideo = carousel.querySelector(".video-wrapper.current");
      currVideo.classList.remove("playing");
      currVideo.classList.remove("current");
      currVideo.querySelector("video").pause();

      const nextVideo = currVideo.previousElementSibling;
      nextVideo.classList.add("playing");
      nextVideo.classList.add("current");
      nextVideo.querySelector("video").play();
      nextVideo.querySelector("video").muted =
        gallery.classList.contains("is-mute");

      const newIndex = currIndex - 1;
      carousel.style.transform = `translateY(-${newIndex * videoHeight}px)`;
      carousel.setAttribute("data-current-index", newIndex);

      if (newIndex == 0) navUp.setAttribute("disabled", "disabled");
      if (newIndex < maxIndex) navDown.removeAttribute("disabled");
    });

    navDown.addEventListener("click", function (e) {
      e.preventDefault();
      const currIndex = carousel.dataset.currentIndex;
      const maxIndex = carousel.dataset.maxIndex;

      if (currIndex === maxIndex) return;

      const videoHeight = carousel.querySelector(".video-wrapper").offsetHeight;
      const currVideo = carousel.querySelector(".video-wrapper.current");
      currVideo.classList.remove("playing");
      currVideo.classList.remove("current");
      currVideo.querySelector("video").pause();

      const nextVideo = currVideo.nextElementSibling;
      nextVideo.classList.add("playing");
      nextVideo.classList.add("current");
      nextVideo.querySelector("video").play();
      nextVideo.querySelector("video").muted =
        gallery.classList.contains("is-mute");

      const newIndex = Number(currIndex) + 1;
      carousel.style.transform = `translateY(-${newIndex * videoHeight}px)`;
      carousel.setAttribute("data-current-index", newIndex);

      if (newIndex == maxIndex) navDown.setAttribute("disabled", "disabled");
      if (newIndex >= 1) navUp.removeAttribute("disabled");
    });

    let startX, startY, endX, endY;
    let isSwiping = false; // Flag to track if a swipe is in progress

    carousel.addEventListener("touchstart", function (e) {
      const touchStart = e.touches[0];
      startX = touchStart.clientX;
      startY = touchStart.clientY;
      isSwiping = false; // Reset the swipe flag
    });

    carousel.addEventListener("touchmove", function (e) {
      if (window.innerWidth <= 1024) {
        const touchMove = e.touches[0];
        endX = touchMove.clientX;
        endY = touchMove.clientY;

        const deltaY = endY - startY;

        if (Math.abs(deltaY) > Math.abs(endX - startX)) {
          isSwiping = true;
          e.preventDefault();
        }
      }
    });

    carousel.addEventListener("touchend", function (e) {
      if (window.innerWidth <= 1024) {
        if (gallery.classList.contains("expanded")) {
          const touchEnd = e.changedTouches[0];
          endX = touchEnd.clientX;
          endY = touchEnd.clientY;

          const deltaX = endX - startX;
          const deltaY = endY - startY;

          if (Math.abs(deltaX) < Math.abs(deltaY)) {
            if (deltaY > 25) {
              navUp.dispatchEvent(new Event("click"));
            } else if (deltaY < -25) {
              navDown.dispatchEvent(new Event("click"));
            }
          }
        }
      }
      isSwiping = false;
    });

    carousel.addEventListener("touchcancel", function () {
      isSwiping = false;
    });

    function shrinkGallery(event) {
      if (
        !gallery.contains(event.target) &&
        !this.contains(event.target) &&
        window.innerWidth <= 1024
      ) {
        gallery.classList.remove("expanded");
      }
    }

    function debounce(fn, wait = 150, { leading = false } = {}) {
      let t,
        didLead = false;

      return (...args) => {
        const callNow = leading && !t && !didLead;
        clearTimeout(t);

        if (callNow) {
          didLead = true;
          fn(...args);
        }

        t = setTimeout(() => {
          t = null;
          didLead = false;
          if (!leading) fn(...args);
          else fn(...args); // trailing too
        }, wait);
      };
    }

    function recalculateGalleryPosition() {
      const currIndex = carousel.dataset.currentIndex;
      const videoHeight = carousel.querySelector(".video-wrapper").offsetHeight;
      carousel.style.transform = `translateY(-${currIndex * videoHeight}px)`;
      carousel.setAttribute("data-current-index", currIndex);
    }

    const closeBtn = document.querySelector(".close-pip-gallery");
    closeBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      document.querySelector(".pip-gallery")?.remove();
      document.removeEventListener("click", shrinkGallery.bind(this));
    });

    gallery.addEventListener("click", function (e) {
      if (window.innerWidth <= 1024) {
        gallery.classList.add("expanded");
      }
    });

    gallery
      .querySelectorAll(".product-form__submit, .video-share")
      .forEach((btn) => {
        btn.addEventListener("click", () => {
          const currVideo = carousel.querySelector(".video-wrapper.current");
          currVideo.classList.remove("playing");
          currVideo.querySelector("video").pause();
        });
      });

    document.addEventListener("click", shrinkGallery.bind(this));
    window.addEventListener(
      "resize",
      debounce(
        () => {
          recalculateGalleryPosition();
        },
        200,
        { leading: true }
      )
    );
  }
}

customElements.define("video-gallery", VideoGallery);

class VideoGalleryElement extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector("video");
    this.form = this.createForm();
    this.btnPlay = this.querySelector(".video-toggle-play");
    this.btnMute = this.querySelector(".video-toggle-mute");
    this.btnPip = this.querySelector(".video-pip");
  }

  connectedCallback() {
    this.setupControls();
  }

  desconnectedCallback() {
    this.removeControls();
  }

  createForm() {
    const form = document.createElement("form");
    form.setAttribute("action", "/cart/add");
    form.setAttribute("method", "POST");
    form.setAttribute("data-product-id", this.dataset.productId);
    form.setAttribute("enctype", "multipart/form-data");

    const inputId = document.createElement("input");
    inputId.setAttribute("type", "hidden");
    inputId.setAttribute("name", "id");
    inputId.setAttribute("value", this.dataset.variantId);

    const inputQt = document.createElement("input");
    inputQt.setAttribute("type", "hidden");
    inputQt.setAttribute("name", "quantity");
    inputQt.setAttribute("value", 1);

    const button = document.createElement("button");
    button.setAttribute(
      "id",
      "gallery-product-add-to-cart-" +
        this.dataset.productId +
        "-" +
        this.dataset.index
    );
    button.setAttribute("type", "submit");
    button.setAttribute("name", "add");
    button.setAttribute("data-btn-addtocart", "");
    button.setAttribute("data-available", this.dataset.available);
    button.classList =
      "product-form__submit button button--primary button--pip-form";
    button.insertAdjacentHTML(
      "beforeend",
      `
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-cart w-h-24">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path class="wheel" d="M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z" stroke="#333232" stroke-width="1.5"></path>
              <path class="wheel" d="M16.5 18.0001C17.3284 18.0001 18 18.6716 18 19.5001C18 20.3285 17.3284 21.0001 16.5 21.0001C15.6716 21.0001 15 20.3285 15 19.5001C15 18.6716 15.6716 18.0001 16.5 18.0001Z" stroke="#333232" stroke-width="1.5"></path>
              <path d="M2.26121 3.09184L2.50997 2.38429H2.50997L2.26121 3.09184ZM2.24876 2.29246C1.85799 2.15507 1.42984 2.36048 1.29246 2.75124C1.15507 3.14201 1.36048 3.57016 1.75124 3.70754L2.24876 2.29246ZM4.58584 4.32298L5.20507 3.89983V3.89983L4.58584 4.32298ZM5.88772 14.5862L5.34345 15.1022H5.34345L5.88772 14.5862ZM20.6578 9.88275L21.3923 10.0342L21.3933 10.0296L20.6578 9.88275ZM20.158 12.3075L20.8926 12.4589L20.158 12.3075ZM20.7345 6.69708L20.1401 7.15439L20.7345 6.69708ZM19.1336 15.0504L18.6598 14.469L19.1336 15.0504ZM5.70808 9.76V7.03836H4.20808V9.76H5.70808ZM2.50997 2.38429L2.24876 2.29246L1.75124 3.70754L2.01245 3.79938L2.50997 2.38429ZM10.9375 16.25H16.2404V14.75H10.9375V16.25ZM5.70808 7.03836C5.70808 6.3312 5.7091 5.7411 5.65719 5.26157C5.60346 4.76519 5.48705 4.31247 5.20507 3.89983L3.96661 4.74613C4.05687 4.87822 4.12657 5.05964 4.1659 5.42299C4.20706 5.8032 4.20808 6.29841 4.20808 7.03836H5.70808ZM2.01245 3.79938C2.68006 4.0341 3.11881 4.18965 3.44166 4.34806C3.74488 4.49684 3.87855 4.61727 3.96661 4.74613L5.20507 3.89983C4.92089 3.48397 4.54304 3.21763 4.10241 3.00143C3.68139 2.79485 3.14395 2.60719 2.50997 2.38429L2.01245 3.79938ZM4.20808 9.76C4.20808 11.2125 4.22171 12.2599 4.35876 13.0601C4.50508 13.9144 4.79722 14.5261 5.34345 15.1022L6.43198 14.0702C6.11182 13.7325 5.93913 13.4018 5.83723 12.8069C5.72607 12.1578 5.70808 11.249 5.70808 9.76H4.20808ZM10.9375 14.75C9.52069 14.75 8.53763 14.7482 7.79696 14.6432C7.08215 14.5418 6.70452 14.3576 6.43198 14.0702L5.34345 15.1022C5.93731 15.7286 6.69012 16.0013 7.58636 16.1283C8.45674 16.2518 9.56535 16.25 10.9375 16.25V14.75ZM4.95808 6.87H17.0888V5.37H4.95808V6.87ZM19.9232 9.73135L19.4235 12.1561L20.8926 12.4589L21.3923 10.0342L19.9232 9.73135ZM17.0888 6.87C17.9452 6.87 18.6989 6.871 19.2937 6.93749C19.5893 6.97053 19.8105 7.01643 19.9659 7.07105C20.1273 7.12776 20.153 7.17127 20.1401 7.15439L21.329 6.23978C21.094 5.93436 20.7636 5.76145 20.4632 5.65587C20.1567 5.54818 19.8101 5.48587 19.4604 5.44678C18.7646 5.369 17.9174 5.37 17.0888 5.37V6.87ZM21.3933 10.0296C21.5625 9.18167 21.7062 8.47024 21.7414 7.90038C21.7775 7.31418 21.7108 6.73617 21.329 6.23978L20.1401 7.15439C20.2021 7.23508 20.2706 7.38037 20.2442 7.80797C20.2168 8.25191 20.1002 8.84478 19.9223 9.73595L21.3933 10.0296ZM16.2404 16.25C17.0021 16.25 17.6413 16.2513 18.1566 16.1882C18.6923 16.1227 19.1809 15.9794 19.6074 15.6318L18.6598 14.469C18.5346 14.571 18.3571 14.6525 17.9744 14.6994C17.5712 14.7487 17.0397 14.75 16.2404 14.75V16.25ZM19.4235 12.1561C19.2621 12.9389 19.1535 13.4593 19.0238 13.8442C18.9007 14.2095 18.785 14.367 18.6598 14.469L19.6074 15.6318C20.0339 15.2842 20.2729 14.8346 20.4453 14.3232C20.6111 13.8312 20.7388 13.2049 20.8926 12.4589L19.4235 12.1561Z" fill="#333232"></path>
              <path class="plus" d="M13 13V11M13 11V9M13 11H15M13 11H11" stroke="#333232" stroke-width="1.5" stroke-linecap="round"></path>
            </g>
          </svg>
          ${this.dataset.available == "true" ? '<span class="btn-tooltip">Adicionar</span>' : '<span class="btn-tooltip">Esgotado</span>'}
        `
    );
    if (this.dataset.available != "true") {
      button.setAttribute("disabled", "disabled");
    }

    form.appendChild(inputId);
    form.appendChild(inputQt);
    form.appendChild(button);

    return form;
  }

  setupControls() {
    if (!this.video) return;

    if (this.btnPlay && !this.btnPlay.classList.contains("listener-attached")) {
      this.btnPlay.classList.add("listener-attached");
      this.btnPlay.addEventListener("click", this.togglePlay.bind(this));
    }

    if (this.btnMute && !this.btnMute.classList.contains("listener-attached")) {
      this.btnMute.classList.add("listener-attached");
      this.btnMute.addEventListener("click", this.toggleMute.bind(this));
    }

    if (this.btnPip && !this.btnPip.classList.contains("listener-attached")) {
      this.btnPip.classList.add("listener-attached");
      this.btnPip.addEventListener("click", this.pipVideo.bind(this));
    }
  }

  removeControls() {
    this.btnPlay?.classList.remove("listener-attached");
    this.btnMute?.classList.remove("listener-attached");
    this.btnPip?.classList.remove("listener-attached");

    this.btnPlay?.removeEventListener("click", this.togglePlay.bind(this));
    this.btnMute?.removeEventListener("click", this.toggleMute.bind(this));
    this.btnPip?.removeEventListener("click", this.pipVideo.bind(this));
  }

  togglePlay(e) {
    e.stopPropagation();

    if (this.video.paused) {
      this.btnPlay.classList.add("playing");
      this.video.play().catch(() => {
        this.btnPlay?.classList.remove("playing");
      });
    } else {
      this.btnPlay.classList.remove("playing");
      this.video.pause();
    }
  }

  toggleMute(e) {
    e.stopPropagation();
    this.video.muted = !this.video.muted;
    this.btnMute.classList.toggle("playing", !this.video.muted);
  }

  pipVideo(e) {
    e.stopPropagation();
    e.preventDefault();

    const el = this.btnPip.closest(".swiper-slide-active");
    if (!el) return;
    this.video.pause();
    this.btnPlay.classList.remove("playing");
    const gallery = this.closest("video-gallery");
    gallery.showPiP(Number(this.dataset.index));
  }
}

customElements.define("video-gallery-element", VideoGalleryElement);
